var _rect, _text, _text2, _text3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConceptualArchitecture1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1700,
    height: 2380,
    viewBox: "0 0 1700 2380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1700,
    height: 2380,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 56,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#C4661E",
    letterSpacing: 2
  }, "ACME PR INTELLIGENCE  \xB7  CONCEPTUAL ARCHITECTURE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 100,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#152451"
  }, "A layered stack \u2014 UI on top, sources at the foundation.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 126,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#727891"
  }, "Each layer has a single concern. Cross-cutting concerns (audit, security, observability, multi-tenancy) apply to every layer.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 36,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#934D17"
  }, "UI / Presentation layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 60,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#C4661E"
  }, "What users see and click"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 86,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 106,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Pulse shell"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 123,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Sidebar, header, RBAC-gated routes"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 86,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 106,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Persona views"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 123,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Operator, CEO, Business admin, Tech admin"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 142,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 162,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Feature surfaces"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 179,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Hot Board, Watch List, Reports, Deep Dive"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 142,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 162,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Tech"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 179,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "React + Vite + Tailwind + lucide-react"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 216,
    x2: 606,
    y2: 244,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,252 600,244 612,244",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#E6F4FB",
    stroke: "#8AC6E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#0093CF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 292,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#00597C"
  }, "API / Application layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 316,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#0076A6"
  }, "HTTP endpoints the UI talks to"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 342,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC6E7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 362,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "REST API"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 379,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Auth, RBAC enforcement, request validation"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 342,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC6E7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 362,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Real-time push"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 379,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "WebSocket / SSE for live HOT scores, alerts"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 398,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC6E7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 418,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Action handlers"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 435,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Send, edit, defer, reject, log placement"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 398,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC6E7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 418,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Tech"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 435,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "FastAPI on Cloud Run"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 472,
    x2: 606,
    y2: 500,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,508 600,500 612,500",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#009391"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 548,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#005A58"
  }, "Integrations layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 572,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#007674"
  }, "Inbound and outbound connections to external services"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 598,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 618,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Outlook / Gmail"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 635,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Outbound: send pitches"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 598,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 618,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "MS Teams webhook"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 635,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Outbound: client hot-story alerts"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 654,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 674,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "HubSpot CRM"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 691,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Bidirectional: reporter relationship sync"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 654,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 674,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Email digest service"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 691,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Outbound: scheduled client digests"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 728,
    x2: 606,
    y2: 756,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,764 600,756 612,756",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 768,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 768,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#152451"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 804,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#0C1631"
  }, "Engine / Orchestration layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 828,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#101D41"
  }, "The pipeline that runs the work"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 854,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 874,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Job runner"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 891,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Scheduled + ad-hoc, Cloud Run jobs"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 854,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 874,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Pipeline orchestrator"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 891,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Sequences ingestion to enrichment to scoring to drafting"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 910,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 930,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Workflow state machine"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 947,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Pitch lifecycle: drafted, sent, replied, placed"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 910,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 930,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Resilience primitives"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 947,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Retry, backoff, circuit breakers, idempotency"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 984,
    x2: 606,
    y2: 1012,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,1020 600,1012 612,1012",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1024,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#FDE7EE",
    stroke: "#F68BAA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1024,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#ED145B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1060,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#8E0C37"
  }, "Agent layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1084,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#BE1049"
  }, "Modular agents \u2014 one job, one prompt, one interface"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1110,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#F68BAA",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1130,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Scoring agents"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1147,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Relevance scorer, Hotness scorer, Composite scorer"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1110,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#F68BAA",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1130,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Matching agents"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1147,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Expert ranker, Guideline checker, Reporter ranker, Conflict checker"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1166,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#F68BAA",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1186,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Drafting agents"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1203,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Template selector, Drafter, Self-critic"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1166,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#F68BAA",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1186,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Enrichment + learning"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1203,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Domain tagger, Placement detector, Edit-pattern miner"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 1240,
    x2: 606,
    y2: 1268,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,1276 600,1268 612,1268",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1280,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1280,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#92278F"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1316,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#581756"
  }, "LLM / Model layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1340,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#751F73"
  }, "The AI primitives the agents call"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1366,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1386,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Foundation models"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1403,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Claude (primary), GPT (fallback), per-agent selection"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1366,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1386,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Embeddings"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1403,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Vertex AI text embeddings for similarity retrieval"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1422,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1442,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Prompt registry"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1459,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Versioned, testable, deployable templates"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1422,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1442,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Eval harness"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1459,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Quality gates before any prompt or model deploy"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 1496,
    x2: 606,
    y2: 1524,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,1532 600,1524 612,1524",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1536,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#F7F8E9",
    stroke: "#D2DA98",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1536,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#B0BC22"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1572,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#697114"
  }, "Data / Knowledge layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1596,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#697114"
  }, "Where the graph lives \u2014 the proprietary moat"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1622,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D2DA98",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1642,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Operational DB"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1659,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Postgres: pitches, actions, statuses, audit"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1622,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D2DA98",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1642,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Analytical warehouse"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1659,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "BigQuery: scoring, stats, attribution"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1678,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D2DA98",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1698,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Vector store"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1715,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "pgvector: embeddings for matching and search"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1678,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#D2DA98",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1698,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Object storage + cache"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1715,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "GCS for assets, Redis for hot-path"), /*#__PURE__*/React.createElement("line", {
    x1: 606,
    y1: 1752,
    x2: 606,
    y2: 1780,
    stroke: "#F58025",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606,1788 600,1780 612,1780",
    fill: "#F58025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1792,
    width: 1212,
    height: 206,
    rx: 14,
    fill: "#FFFBE6",
    stroke: "#FFEC85",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1792,
    width: 6,
    height: 206,
    rx: 3,
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1828,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#998400"
  }, "Sources layer"), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 1852,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#998400"
  }, "Where raw data enters the system"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1878,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FFEC85",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1898,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "News feeds"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1915,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "RSS, news APIs, Playwright scrapers"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1878,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FFEC85",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1898,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "CRM systems"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1915,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "HubSpot for reporter contact + relationship state"), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1934,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FFEC85",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1954,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Outlet metadata"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1971,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Tier, type, beat lookups"), /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 1934,
    width: 566,
    height: 46,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#FFEC85",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1954,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#152451"
  }, "Manual entry"), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 1971,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Coordinator-logged responses and placements"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1292,160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 1838,
    rx: 14,
    fill: "#F8F9FC",
    stroke: "#9CA1B7",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 36,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#5A5F73",
    letterSpacing: 2
  }, "CROSS-CUTTING"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 64,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#152451"
  }, "Concerns"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 86,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#727891"
  }, "Apply to every layer above"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 116,
    width: 328,
    height: 148,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 146,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#152451"
  }, "Observability"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 170,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 174,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Structured logs"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 194,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 198,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Distributed tracing"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 218,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 222,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Metrics + dashboards"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 242,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 246,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Cost tracking per agent"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 280,
    width: 328,
    height: 148,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 310,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#152451"
  }, "Audit &amp; compliance"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 334,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 338,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Append-only audit log"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 358,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 362,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Agent trace ledger"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 382,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 386,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Versioned configs"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 406,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 410,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Defensible months later"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 444,
    width: 328,
    height: 148,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 474,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#152451"
  }, "Security"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 498,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 502,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "RBAC enforcement"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 522,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 526,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Per-client data isolation"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 546,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 550,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Secret management"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 570,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 574,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Encryption at rest + transit"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 608,
    width: 328,
    height: 148,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DCDEEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 638,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#152451"
  }, "Multi-tenancy"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 662,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 666,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Per-client config"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 686,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 690,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Conflict isolation"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 710,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 714,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Feature flags"), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 734,
    r: 2.5,
    fill: "#9CA1B7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 738,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12.5,
    fill: "#5A5F73"
  }, "Onboarding-as-config"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConceptualArchitecture1);
export default __webpack_public_path__ + "static/media/conceptual_architecture_1.f254dcf145114f5653cfca31a3731a0f.svg";
export { ForwardRef as ReactComponent };